import React, { FC } from 'react';

import { useFromChainWalletAddress } from '../hooks';

import Container from '../components/Container';
import Pagination from '../components/Pagination';
import TransactionTable from './history/TransactionTable';
import ModalWalletDetail from '../components/ModalWalletDetail';
import Header from '../components/Bridge/Header/header';
import ModalNetwork from '../components/ModalNetwork';
import { NavBar } from '../components';

const SceneHistory: FC = () => {
  const fromChainWalletAddress = useFromChainWalletAddress();

  if (!fromChainWalletAddress) {
    return (
      <>
        <Header />
        <Container>
          <NavBar />
          <div className="bridge-explorer wow fadeIn fast">
            <i className="icon icon-4x icon-link" />
            <h4 style={{ marginTop: 6 }}>Your Wallet should be connected.</h4>
            <p>Connect Your Wallet</p>
          </div>
        </Container>
        <ModalWalletDetail />
      </>
    );
  }

  return (
    <>
      <Header />
      <Container>
        <NavBar />
        <div className="bridge-explorer wow fadeIn fast">
          <div className="headline">
            <i data-icon="history" />
            <p>Your Transaction list.</p>
          </div>
          <TransactionTable walletAddress={fromChainWalletAddress} />
          <Pagination />
        </div>
      </Container>
      <ModalWalletDetail />
      <ModalNetwork />
    </>
  );
};

export default SceneHistory;
